import fetch from 'scripts/utils/fetch'

const DEFAULT_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
}

const fetcher = async (url, options = {}) => {
  const { method = 'get', headers = {}, body } = options

  return fetch(url, {
    method,
    body,
    headers: {
      ...DEFAULT_HEADERS,
      ...headers
    }
  })
}

export default fetcher
